module.exports = __webpack_public_path__ + "static/media/kourakuen.c42c46db.jpg";